import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { formatNumber } from "Utils/Number";
import { IRendererProps } from "../IRendererProps";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { UseNumberRendererStyles } from "./UseNumberRendererStyles";

export const NumberRenderer = WithTranslator((props: IRendererProps): JSX.Element => {
  const {
    fieldName, item, translator, styles, precision
  } = props;
  const value = (item?.[fieldName] as number) ?? 0;
  const styleSet = UseNumberRendererStyles(styles);

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={<FilterToolTipContent fieldName={fieldName} value={value?.toString()} rawValue={`=${value}`} />}
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Text>{formatNumber(translator.getActiveLocale(), value, precision ?? 0)}</Text>
      </div>
    </TooltipHost>
  );
});
